// extracted by mini-css-extract-plugin
module.exports = {"root":"EditAdminPage_root__2cmGP","tabpanel":"EditAdminPage_tabpanel__3jC34","tabItemTitle":"EditAdminPage_tabItemTitle__sMgF-","tabItem":"EditAdminPage_tabItem__nEDix"};